import {useMemo, useState} from "react";
import {
    EBirdChecklistByFamily,
    EBirdMyDataSchema,
    EBirdObservationsBySpecies,
    getFilteredObservations,
    getMonthsWithObservations
} from "ebird-mydata-reader";

export function usePeriodFilter(
    rawData: any[],
    observationsBySpecies: EBirdObservationsBySpecies[],
    checklist: EBirdChecklistByFamily[] = []
) {
    const [year, setYear] = useState<number|string>();
    const [month, setMonth] = useState<number|string>();
    const [filteredObservations, setFilteredObservations] = useState<EBirdMyDataSchema[]>([]);

    const months = useMemo(() => {
        if (!year) {
            return [];
        }

        const parsedYear = year === 'life' ? year : parseInt(year as string);
        return getMonthsWithObservations(rawData, parsedYear);
    }, [rawData, year]);

    const setTimePeriod = (year: string, month: string) => {
        const parsedYear = year === 'life' ? year : parseInt(year);
        const parsedMonth = parseInt(month) ?? null;
        setYear(year);
        setMonth(month);
        setFilteredObservations(getFilteredObservations(rawData, parsedYear, parsedMonth));
    }

    const setSpeciesFilter = (taxonomicOrder: number) => {
        const checklistSpecies = checklist
            .flatMap(family => family.speciesList)
            .find(species => {
                return species.taxonomicOrder === taxonomicOrder ||
                    species.alternateTaxonomicOrders?.includes(taxonomicOrder);
            });
        const taxonomicOrders = new Set<number>([
            checklistSpecies?.taxonomicOrder ?? taxonomicOrder,
            ...(checklistSpecies?.alternateTaxonomicOrders ?? [])
        ]);
        const matchingSpeciesGroups = observationsBySpecies.filter(el => taxonomicOrders.has(el.taxonomicOrder));
        const foundSpecies = matchingSpeciesGroups[0];

        if (foundSpecies) {
            setFilteredObservations(matchingSpeciesGroups.flatMap(species => species.observations));
        }

        return foundSpecies;
    }

    const resetPeriodFilter = () => {
        setYear(undefined);
        setMonth(undefined);
        setFilteredObservations([]);
    }

    return {
        year,
        month,
        months,
        filteredObservations,
        setYear,
        setMonth,
        setTimePeriod,
        setSpeciesFilter,
        resetPeriodFilter
    }
}
